export default __webpack_public_path__ + "static/media/appPhoto.4c4f73b1.png";